import { render, staticRenderFns } from "./hallTicket.html?vue&type=template&id=24f4d85d&external"
import script from "./hallTicket.vue?vue&type=script&lang=js"
export * from "./hallTicket.vue?vue&type=script&lang=js"
import style0 from "./hallTicket.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports